import './InsurSmartConfirmation.scss';

import Auth from '@aws-amplify/auth';
import { Button } from '@boi/core/lib';
import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';

import { config, customer_config } from '../../amplify.config';
import { commonPageStylesIdentifier, HOME_QUOTE_THANK_YOU_STORAGE, SELECTED_HOME_QUOTE_STORAGE } from '../../constants';
import { FORCE_LOGIN } from '../../constants/home';
import { CommonPageStylesDesktopBackButton } from '../../constants/styleConstants/commonClassNames';
import { getObjectFromSessionStorage, isAgent, saveInSessionStorage } from '../../helpers';
import { routes } from '../../routes';
import { getUsers } from '../../services/retriveUser';
import { backToHome } from '../../constants/buttonLabelConstants';

const InsurSmartConfirmation = () => {
  const className = 'insur_smart_confirmation';
  const [selectedQuote, setSelectedQuote] = useState({});
  const [quoteData, setQuoteData] = useState({});
  const history = useHistory();


  const nextStepPoints = () => {
    return <div><h2>The next steps are as follows:</h2>
      <ol>
        <li>You'll receive an email shortly with full InsurSmart terms - please review.</li>
        <li>We'll start your insurance wallet registration now - complete within 7 days.</li>
        <li>Your home insurance will start before your mortgage - direct debit begins once active.</li>
        <li>If anything changes or you have questions, contact us straight away.</li>
      </ol>
    </div>;
  };

  useEffect(() => {
    setSelectedQuote(getObjectFromSessionStorage(SELECTED_HOME_QUOTE_STORAGE));
    setQuoteData(getObjectFromSessionStorage(HOME_QUOTE_THANK_YOU_STORAGE));
  }, []);

  const insuranceType = 'home';

  const displayPolicyCode = () => {
    const policyCode = selectedQuote?.policy_code;
    return <div><h2>Policy code: {policyCode}</h2></div>;
  };

  const displayThankYouMessage = () => {
    const fullName = selectedQuote?.quote_policy_holder_details?.first_name + ' ' + selectedQuote?.quote_policy_holder_details?.last_name;
    return <div><h2>Thank you {fullName}</h2></div>;
  };

  const displayCreateAccountButton = () => {
    return (<div className={`${className}__createAccButton__container`}>
      {displayBackButton()}
      <Button
        onClick={() => {history.push(routes.createAccount.url);}}
        id={`${className}__createAccountButton`}
        data-testid={`${className}__createAccountButton`}>
        Create Account
      </Button>
    </div>);
  };

  const displayBackButton = () => {
    return <Button
        onClick={() => {history.push(routes.wallet.url)}}
        id={`${className}__backToHomeButton`}
        data-testid={`${className}__backToHomeButton`}>
        {backToHome}
      </Button>
  }

  const goToBindPage = () => {
    if (isAgent()) {
      Auth.configure(customer_config);
      getUsers({
        dropdownValue: 'email',
        searchInput: quoteData?.aboutYouObj?.email || ''
      })
        .then((res: any) => {
          if (res?.user_list?.length > 0) {
            journeyToBind(quoteData, true, true);
          } else {
            journeyToBind(quoteData, false, true);
          }
        })
        .catch((e: any) => {
          console.error(e);
        });
    }
  };

  const journeyToBind = (
      quoteData: any,
      userExistOrLoggedIn: any,
      isAgent: boolean
    ) => {
      if (isAgent) {
        Auth.configure(config);
      }
      if (userExistOrLoggedIn) {
        history.push(`${routes.makePayment.url}${insuranceType}`);
      } else {
        saveInSessionStorage(
          FORCE_LOGIN,
          JSON.stringify({ forceLogIn: true, insuranceType: insuranceType, insurSmart: true })
        );
        history.push(`${routes.signUp.url}`);
        
      }
    };

  const displayProceedButton = () => {
    return (<div className={`${className}__proceedBindButton__container`}>
      {displayBackButton()}
      <Button
        onClick={() => goToBindPage()}
        id={`${className}__proceedBindButton`}
        data-testid={`${className}__proceedBindButton`}>
        Proceed to Bind
      </Button>
    </div>);
  };

  const displayActionButtons = () => {
    const smartInsurQuote = quoteData?.yourCoverObj?.itb;
    return smartInsurQuote ? displayProceedButton() : displayCreateAccountButton();
  }

  return (<div className={`${className}`}>
    <div className={`${className}__card`}>
      <div className={`${className}__contentContainer`}>
        <div
          className={`${commonPageStylesIdentifier} ${CommonPageStylesDesktopBackButton}`}
        >
        </div>
        <div className={`${className}__card`}>
          <div className={`${className}__contentContainer`}>
            <div
              className={`${className}__paddedContainer`}
            >
              {displayPolicyCode()}
              {displayThankYouMessage()}
              {nextStepPoints()}
              {displayActionButtons()}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>);
};

export default InsurSmartConfirmation;
